import { createBoundaryTerritoryStyleFromResponse } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.factory';
import { type BoundaryTerritoryStyleRequest } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.repository';
import { type BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export const boundaryFillDefaultOpacity = .5;

export const restoreBTGDefaultColors = (boundaryTerritoryGroup: BoundaryTerritoryGroup) => {
  const boundaryTerritoryGroupSettingsStyleDefaults = getBoundaryTerritoryGroupSettingsStyleDefaults();
  return {
    ...boundaryTerritoryGroup,
    settings: {
      ...boundaryTerritoryGroup.settings,
      style: {
        ...boundaryTerritoryGroup.settings.style,
        lineColor: boundaryTerritoryGroupSettingsStyleDefaults.lineColor,
        gradientColors: boundaryTerritoryGroupSettingsStyleDefaults.gradientColors,
      },
    },
  };
};

export const boundaryTerritoryGroupCreateSettingsStyleDefaults: Readonly<BoundaryTerritoryStyleRequest> = {
  line_color: '#000',
  line_width: 1,
  gradient_colors: {
    minimal: {
      color: '#0066FF',
    },
    low: {
      color: '#00FF00',
    },
    medium: {
      color: '#FFFF00',
    },
    high: {
      color: '#FF0000',
    },
  },
};

export const getBoundaryTerritoryGroupSettingsStyleDefaults =
  () => createBoundaryTerritoryStyleFromResponse(boundaryTerritoryGroupCreateSettingsStyleDefaults);
